/** Link code and verified role metadata never come from decoded JWT claims. */
import { validateJudgeSession, type JudgeSession } from "@/stores/judgeSession";

export function takeRoleCode(): string {
  const code = window.location.hash.slice(1);
  if (window.location.hash)
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
  return code;
}
export function parseRoleRedemption(value: unknown): JudgeSession {
  if (!value || typeof value !== "object") throw new Error("Invalid role response");
  const input = value as Record<string, unknown>;
  const competition = input.competition as Record<string, unknown> | undefined;
  const roles = input.roles;
  const expected =
    input.kind === "judge"
      ? input.is_head_judge === true
        ? ["judge", "head_judge"]
        : ["judge"]
      : input.kind === "starter" || input.kind === "announcer"
        ? [input.kind]
        : [];
  if (
    !expected.length ||
    !Array.isArray(roles) ||
    roles.length !== expected.length ||
    expected.some((role) => !roles.includes(role)) ||
    !competition ||
    typeof competition.id !== "string" ||
    typeof competition.name !== "string" ||
    typeof competition.timezone !== "string" ||
    !(competition.slug === null || typeof competition.slug === "string") ||
    typeof input.principal_key !== "string" ||
    !input.principal_key.startsWith("link-session:") ||
    typeof input.queue_principal_key !== "string" ||
    !input.queue_principal_key.startsWith("link:") ||
    typeof input.token !== "string" ||
    typeof input.expires_at !== "string" ||
    (input.judge_number !== null && typeof input.judge_number !== "number") ||
    (input.kind !== "judge" && input.judge_number !== null)
  )
    throw new Error("Invalid role response");
  new Intl.DateTimeFormat("en", { timeZone: competition.timezone }).format();
  return validateJudgeSession({
    competitionId: competition.id,
    token: input.token,
    principalKey: input.principal_key,
    queuePrincipalKey: input.queue_principal_key,
    roles: expected,
    kind: input.kind as JudgeSession["kind"],
    expiresAt: input.expires_at,
    competitionName: competition.name,
    competitionSlug: competition.slug || undefined,
    timezone: competition.timezone,
    ...(typeof input.judge_number === "number" ? { seat: input.judge_number } : {}),
  });
}
export function roleDestination(session: JudgeSession): string {
  const base = `/competition/${encodeURIComponent(session.competitionId)}`;
  if (session.roles.includes("head_judge")) return `${base}/workspace?role=link`;
  if (session.roles.includes("starter")) return `${base}/run?role=link`;
  if (session.roles.includes("announcer"))
    return `/results/${encodeURIComponent(session.competitionSlug ?? session.competitionId)}/announcer?role=link`;
  return `${base}/judge?role=link`;
}
